import { c as _c } from "react/compiler-runtime";
import { Tabbar } from '@systemeio/components';
import type { ReactNode } from 'react';
export interface MailEditorSidebarTab {
  Component: ReactNode;
  showErrorOutline?: boolean;
  title: string;
  value: string;
}
interface MailEditorSidebarTabsProps {
  tabs: MailEditorSidebarTab[];
}
export function MailEditorSidebarTabs(t0) {
  const $ = _c(9);
  const {
    tabs
  } = t0;
  const t1 = tabs[0]?.value;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      className: "px-5"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== tabs) {
    t3 = tabs.map(_temp);
    $[1] = tabs;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== tabs) {
    t4 = tabs.map(_temp2);
    $[3] = tabs;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t3 || $[7] !== t4) {
    t5 = <Tabbar className="bg-bg-primary border-border-100 flex flex-col gap-5 rounded-xl border pt-3 pb-5" defaultValue={t1} listProps={t2} tabs={t3}>{t4}</Tabbar>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp2(t0) {
  const {
    Component,
    value: value_0
  } = t0;
  return <Tabbar.Panel className="px-5" key={value_0} value={value_0}>{Component}</Tabbar.Panel>;
}
function _temp(t0) {
  const {
    showErrorOutline,
    title,
    value
  } = t0;
  return {
    children: title,
    hasError: showErrorOutline,
    overflowLabel: title,
    value
  };
}